import React, { useState } from 'react';
import { API_URL } from "../config/API_URLS.tsx";
import { authenticatedFetch } from "../auth/RequestSigner.tsx";
import SuccessModal from "./SuccessModal.tsx";
import ErrorModal from "./ErrorModal.tsx";

const RegistrationFormUser = () => {
    const [formData, setFormData] = useState({
        name: '',
        last_name: '',
        document: '',
        ficha: '',
        email: '',
        photo: '',
        finish_date: ''
    });

    const [formVehicleDataMoto, setFormVehicleDataMoto] = useState({
      marca: 'Yamaha',
      placa: '',
      modelo: '',
      color: '',
      observaciones: '',
      foto: '',
      tarjeta_propiedad: '',
    });

    const [continueButton, setContinueButton] = useState(false);
    const [vehicleType, setVehicleType] = useState("tipo");
    const [image, setImage] = useState(null);
    const [vehiclePhoto, setVehiclePhoto] = useState(null);
    const [propertyCardPhoto, setpropertyCardPhoto] = useState(null);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [documentType, setDocumentType] = useState("tipodoc");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleVehicleTypeChange = (event) => {
      setVehicleType(event.target.value);
    };

    const handleDocumentType = (event) => {
      const selectedType = event.target.value;
      setDocumentType(selectedType);

      if (selectedType !== 'tipodoc') {
        setErrors((prevErrors) => {
          const { document, ...restErrors } = prevErrors;
          if (document === "elige un tipo de documento") {
            return restErrors;
          }
          return prevErrors;
        });
      }
    };

    const validateFields = (name, value) => {
      let error = '';
      if (name === 'ficha' && !/^[0-9]+$/.test(value)) {
        error = 'Por favor ingresa un número de ficha válido.';
      }
      else if (name === 'document' && !/^[0-9]+$/.test(value)) {
        error = 'Por favor ingresa un número de documento válido.';      
      }
      else if (name === 'email' && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(value)) {
        error = 'Por favor ingresa un correo válido.';
      }    
      else if (name === 'document' && value) {  
        if (documentType === 'tipodoc') {
          error = 'Elige un tipo de documento';
        }
      }     
      return error;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        const error = validateFields(name, value);
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: error,
        }));
    };

    const handleInputChange2 = (e) => {
      const { name, value } = e.target;
      setFormVehicleDataMoto({
          ...formVehicleDataMoto,
          [name]: value
      });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setErrorMessage("");
        let urlAPI = '';
        let newForm1 = {};      

        if (vehicleType === 'motocicleta') {
            urlAPI = `${API_URL}/v1/motocicleta-registration`;
            newForm1 = { ...formVehicleDataMoto, user_document: formData.document };
        }
        if (vehicleType === 'bicicleta') {
            urlAPI = `${API_URL}/v1/bicicleta-registration`;
            const { placa, ...rest } = formVehicleDataMoto;
            newForm1 = {
              numero_marco: placa,
              ...rest,
              user_document: formData.document
            };
        }

        try {
            const response = await authenticatedFetch(`${API_URL}/v1/aprendiz-registration`,
             {
                method: 'post',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.detail);
            }

            const response2 = await authenticatedFetch(urlAPI,
              {
                  method: 'post',
                  body: JSON.stringify(newForm1),
                  headers: {
                      'Content-Type': 'application/json'
                  }
              });

            if (!response2.ok) {
                throw new Error('Error en la solicitud');
            }

            setShowSuccessModal(true);
            setTimeout(() => {
                window.location.href = '/';
            }, 3000);

        } catch (error) {
            console.error('Error:', error);
            setErrorMessage(error.message);
            setShowErrorModal(true);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleImageChange = (e) => {
      const selectedImage = e.target.files[0];
      setImage(selectedImage);
      sendImageToS3(selectedImage);
    };

    const handleVehiclePhoto = (e) => {
      const selectedImage = e.target.files[0];
      setVehiclePhoto(selectedImage);
      sendImageToS3Vehicle(selectedImage, 'foto');
    };

    const handleVehiclePhotoProperty = (e) => {
      const selectedImage = e.target.files[0];
      setpropertyCardPhoto(selectedImage);
      sendImageToS3Vehicle(selectedImage, 'tarjeta_propiedad');
    };

    const sendImageToS3 = async (image) => {
      try {
        const formData2 = new FormData();
        formData2.append('image', image);  
        formData2.append('document', '12345');

        const response = await authenticatedFetch(`${API_URL}/v1/upload_img_s3`, {
          method: 'POST',
          body: formData2
        });

        if (!response.ok) {
          throw new Error('Error en la solicitud');
        }

        const data = await response.json();
        setFormData({ ...formData, photo: data.url});

      } catch (error) {
        console.error('Error:', error);
      }
    };

    const sendImageToS3Vehicle = async (image, fieldName) => {
      try {
        const formData2 = new FormData();
        formData2.append('image', image);        

        const response = await authenticatedFetch(`${API_URL}/v1/upload_img_s3`, {
          method: 'POST',
          body: formData2
        });

        if (!response.ok) {
          throw new Error('Error en la solicitud');
        }

        const data = await response.json();
        setFormVehicleDataMoto(prevState => ({
          ...prevState,
          [fieldName]: data.url
        }));

      } catch (error) {
        console.error('Error:', error);
      }
    };

    const isFormValid = () => {
      return (
        Object.values(errors).every((error) => !error) &&
        formData.name &&
        formData.last_name &&
        formData.document &&
        formData.ficha &&
        formData.email &&
        formData.finish_date &&
        image
      );
    };

    const handleContinueButton = () => {
      setContinueButton(true);
    };

    const handleCloseErrorModal = () => {
      setShowErrorModal(false);
    };

    const handleCloseSuccessModal = () => {
      setShowSuccessModal(false);
      window.location.href = '/';
    };

    const isVehicleFormValid = () => {
      return (
        formVehicleDataMoto.placa && 
        formVehicleDataMoto.modelo && 
        formVehicleDataMoto.color && 
        vehiclePhoto && 
        propertyCardPhoto &&
        vehicleType !== "tipo"
      );
    };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 px-4 py-12" data-testid="registration-form-user-container">
      <div className="w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">
          {!continueButton ? 'Datos del Aprendiz' : 'Datos del Vehículo'}
        </h1>

        {!continueButton && ( 
          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200" data-testid="registration-form">
            <div className="space-y-6">
              <div className="mb-4" data-testid="registration-form-name">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="name"
                >
                  Nombres*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Juan"
                  pattern="[a-zA-Z ]{2,254}"
                  title='Este campo solo acepta letras'
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  data-testid="registration-form-name-input"
                />
              </div>

              <div className="mb-4" data-testid="registration-form-last-name">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="last_name"
                >
                  Apellidos*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="text"
                  id="last_name"
                  name="last_name"
                  placeholder="González"
                  pattern="[a-zA-Z ]{2,254}"
                  value={formData.last_name}
                  onChange={handleInputChange}
                  required
                  data-testid="registration-form-last-name-input"
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="documentType"
                >
                  Tipo de documento*
                </label>
                <select 
                  id="documentType"
                  required
                  name='documentType'
                  onChange={handleDocumentType}
                  value={documentType}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                >
                  <option value="tipodoc" disabled>Selecciona tipo de documento</option>
                  <option value="CC">Cédula de ciudadanía</option>
                  <option value="CE">Cédula de extranjería</option>
                  <option value="TI">Tarjeta de identidad</option>
                  <option value="PT">Permiso por protección temporal</option>
                </select>
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="document"
                >
                  Número de documento*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="text"
                  id="document"
                  name="document"
                  placeholder="1020304050"
                  pattern="^[0-9]+"
                  value={formData.document}
                  onChange={handleInputChange}
                  required
                />
                {errors.document && (
                  <p className="mt-1 text-sm text-red-600">{errors.document}</p>
                )}
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="ficha"
                >
                  Número de ficha*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="text"
                  id="ficha"
                  name="ficha"
                  placeholder="2454434" 
                  pattern="^[0-9]+"
                  value={formData.ficha}
                  onChange={handleInputChange}
                  required
                />
                {errors.ficha && (
                  <p className="mt-1 text-sm text-red-600">{errors.ficha}</p>
                )}
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="email"
                >
                  Email*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="email"
                  id="email"
                  name="email"
                  placeholder="john@example.com"
                  onChange={handleInputChange}
                  value={formData.email}
                  required
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                )}
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="finish_date"
                >
                  Fecha de finalización del programa*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="date"
                  id="finish_date"
                  name="finish_date"
                  value={formData.finish_date}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="photo"
                >
                  Foto tipo carnet*
                </label>
                <div className="flex w-full items-center justify-center">
                  <div 
                    className={`w-full flex flex-col items-center p-4 border-2 border-dashed rounded-lg transition-all ${
                      (formData.email && formData.ficha) 
                        ? 'border-amber-300 hover:border-amber-500 cursor-pointer' 
                        : 'border-gray-300 bg-gray-50 cursor-not-allowed'
                    }`}
                    onClick={() => {
                      if (formData.email && formData.ficha) {
                        document.getElementById('foto_carnet').click();
                      }
                    }}
                  >
                    <svg
                      className={`w-10 h-10 mb-2 ${
                        (formData.email && formData.ficha) ? 'text-amber-500' : 'text-gray-400'
                      }`}
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                    </svg>
                    <span className={`text-sm font-medium ${(formData.email && formData.ficha) ? 'text-gray-700' : 'text-gray-400'}`}>
                      Selecciona un archivo
                    </span>
                    <span className="text-xs text-gray-500 mt-1">PNG, JPG, JPEG</span>
                    <input 
                      type="file" 
                      id="foto_carnet" 
                      className="hidden" 
                      accept=".png,.jpg,.jpeg" 
                      onChange={handleImageChange} 
                      disabled={!formData.email || !formData.ficha}
                    />
                  </div>
                </div>

                {image && (
                  <div className="mt-4 p-2 border border-gray-200 rounded-lg">
                    <p className="text-center p-2 text-amber-600 font-medium mb-2">Imagen seleccionada:</p>
                    <div className="rounded-lg overflow-hidden">
                      <img 
                        src={URL.createObjectURL(image)} 
                        alt="Imagen seleccionada" 
                        className="w-full object-cover" 
                      />
                    </div>
                  </div>
                )}
              </div>

              <button
                onClick={handleContinueButton}
                className={`w-full px-4 py-3 rounded-lg shadow-md flex items-center justify-center relative overflow-hidden group ${
                  !isFormValid() ? 'bg-gray-300 cursor-not-allowed text-gray-500' : ''
                }`}
                type="button"
                disabled={!isFormValid()}
              >
                {!isFormValid() ? (
                  <span>Continuar</span>
                ) : (
                  <>
                    <div className="absolute inset-0 bg-gradient-to-t from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
                    <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
                    <span className="relative z-10 font-semibold text-gray-900">Continuar</span>
                  </>
                )}
              </button>
            </div>
          </div>
        )}

        {continueButton && (
          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
            <div className="space-y-6">
              <button
                onClick={() => setContinueButton(false)}
                className="w-full px-4 py-3 text-gray-900 bg-gradient-to-t from-amber-300 to-amber-600 hover:bg-gradient-to-t hover:from-amber-200 to hover:to-amber-500 font-medium rounded-lg shadow-sm hover:bg-gray-200 transition-all mb-4"
                type="button"
              >
                Volver atrás
              </button>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="vehicleType"
                >
                  Tipo de vehículo*
                </label>
                <select
                  id="vehicleType"
                  name="tipoVehiculo"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  onChange={handleVehicleTypeChange}
                  value={vehicleType}
                >
                  <option value="tipo" disabled>Selecciona tipo de vehículo</option>
                  <option value="motocicleta">Motocicleta</option>
                  <option value="bicicleta">Bicicleta</option>
                </select>
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="marca"
                >
                  Marca*
                </label>
                <select
                  id="marca"
                  required
                  name="marca"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  onChange={handleInputChange2}
                  value={formVehicleDataMoto.marca}
                  disabled={vehicleType === 'tipo'}
                >
                  <option value="marca" disabled>Selecciona una marca</option>
                  {vehicleType === "bicicleta" && (
                    <>
                      <option value="Haro">Haro</option>
                      <option value="trek">Trek</option>
                      <option value="specialized">Specialized</option>
                    </>
                  )}
                  {vehicleType === "motocicleta" && (
                    <>
                      <option value="Yamaha">Yamaha</option>
                      <option value="harley-davidson">Harley Davidson</option>
                      <option value="honda">Honda</option>
                    </>
                  )}
                </select>
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="placa"
                >
                  {vehicleType === "motocicleta" ? "Número de placa*" : "Número de marco*"}
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="text"
                  id="placa"
                  name="placa"
                  placeholder={vehicleType === "motocicleta" ? "ABC-123" : "SN12345678"}
                  value={formVehicleDataMoto.placa}
                  onChange={handleInputChange2}
                  required
                  disabled={vehicleType === 'tipo'}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="modelo"
                >
                  Modelo*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="text"
                  id="modelo"
                  name="modelo"
                  placeholder="R15"
                  value={formVehicleDataMoto.modelo}
                  onChange={handleInputChange2}
                  required
                  disabled={vehicleType === 'tipo'}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="color"
                >
                  Color*
                </label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  type="text"
                  id="color"
                  name="color"
                  placeholder="Negro"
                  value={formVehicleDataMoto.color}
                  onChange={handleInputChange2}
                  required
                  disabled={vehicleType === 'tipo'}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="foto"
                >
                  Fotografía del vehículo*
                </label>
                <div className="flex w-full items-center justify-center">
                  <div 
                    className={`w-full flex flex-col items-center p-4 border-2 border-dashed rounded-lg transition-all ${
                      vehicleType !== 'tipo' 
                        ? 'border-amber-300 hover:border-amber-500 cursor-pointer' 
                        : 'border-gray-300 bg-gray-50 cursor-not-allowed'
                    }`}
                    onClick={() => {
                      if (vehicleType !== 'tipo') {
                        document.getElementById('vehicle_photo_upload').click();
                      }
                    }}
                  >
                    <svg
                      className={`w-10 h-10 mb-2 ${vehicleType !== 'tipo' ? 'text-amber-500' : 'text-gray-400'}`}
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                    </svg>
                    <span className={`text-sm font-medium ${vehicleType !== 'tipo' ? 'text-gray-700' : 'text-gray-400'}`}>
                      Selecciona un archivo
                    </span>
                    <span className="text-xs text-gray-500 mt-1">PNG, JPG, JPEG</span>
                    <input 
                      type="file" 
                      accept=".png,.jpg,.jpeg" 
                      className="hidden" 
                      required 
                      onChange={handleVehiclePhoto} 
                      disabled={vehicleType === 'tipo'} 
                      id="vehicle_photo_upload"
                    />
                  </div>
                </div>

                {vehiclePhoto && (
                  <div className="mt-4 p-2 border border-gray-200 rounded-lg">
                    <p className="text-center p-2 text-amber-600 font-medium mb-2">Imagen seleccionada:</p>
                    <div className="rounded-lg overflow-hidden">
                      <img 
                        src={URL.createObjectURL(vehiclePhoto)} 
                        alt="Imagen seleccionada" 
                        className="w-full object-cover" 
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="tarjeta_propiedad"
                >
                  Tarjeta de propiedad*
                </label>
                <div className="flex w-full items-center justify-center">
                  <div 
                    className={`w-full flex flex-col items-center p-4 border-2 border-dashed rounded-lg transition-all ${
                      vehicleType !== 'tipo' 
                        ? 'border-amber-300 hover:border-amber-500 cursor-pointer' 
                        : 'border-gray-300 bg-gray-50 cursor-not-allowed'
                    }`}
                    onClick={() => {
                      if (vehicleType !== 'tipo') {
                        document.getElementById('property_card_upload').click();
                      }
                    }}
                  >
                    <svg
                      className={`w-10 h-10 mb-2 ${vehicleType !== 'tipo' ? 'text-amber-500' : 'text-gray-400'}`}
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                    </svg>
                    <span className={`text-sm font-medium ${vehicleType !== 'tipo' ? 'text-gray-700' : 'text-gray-400'}`}>
                      Selecciona un archivo
                    </span>
                    <span className="text-xs text-gray-500 mt-1">PNG, JPG, JPEG</span>
                    <input 
                      type="file" 
                      className="hidden" 
                      required 
                      accept=".png,.jpg,.jpeg" 
                      onChange={handleVehiclePhotoProperty} 
                      disabled={vehicleType === 'tipo'} 
                      id="property_card_upload"
                    />
                  </div>
                </div>

                {propertyCardPhoto && (
                  <div className="mt-4 p-2 border border-gray-200 rounded-lg">
                    <p className="text-center p-2 text-amber-600 font-medium mb-2">Imagen seleccionada:</p>
                    <div className="rounded-lg overflow-hidden">
                      <img 
                        src={URL.createObjectURL(propertyCardPhoto)} 
                        alt="Imagen seleccionada" 
                        className="w-full object-cover" 
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 font-medium mb-2"
                  htmlFor="observaciones"
                >
                  Observaciones
                </label>
                <textarea
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                  id="observaciones"
                  name="observaciones"
                  placeholder="Ejemplo: Tiene calcomanías en el tanque"
                  value={formVehicleDataMoto.observaciones}
                  onChange={handleInputChange2}
                  disabled={vehicleType === 'tipo'}
                  rows="3"
                />
              </div>

              <button
                onClick={handleSubmit}
                className={`w-full px-4 py-3 rounded-lg shadow-md flex items-center justify-center relative overflow-hidden group ${
                  !isVehicleFormValid() || isSubmitting ? 'bg-gray-300 cursor-not-allowed text-gray-500' : ''
                }`}
                type="submit"
                disabled={!isVehicleFormValid() || isSubmitting}
                data-testid="registration-form-submit-button"
              >
                {!isVehicleFormValid() || isSubmitting ? (
                  <span>
                    {isSubmitting ? (
                      <div className="flex items-center">
                        <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2"></div>
                        <span>Enviando...</span>
                      </div>
                    ) : (
                      "Finalizar"
                    )}
                  </span>
                ) : (
                  <>
                    <div className="absolute inset-0 bg-gradient-to-t from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
                    <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
                    <span className="relative z-10 text-gray-900">Finalizar</span>
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </div>

      <SuccessModal
        isOpen={showSuccessModal}
        onClose={handleCloseSuccessModal}
        message="Solicitud de registro enviada con éxito. Serás redirigido a la página principal."
      />

      <ErrorModal
        isOpen={showErrorModal}
        onClose={handleCloseErrorModal}
        message={errorMessage || "Error al procesar la solicitud. Por favor, intenta nuevamente."}
      />
    </div>
  );
}

export { RegistrationFormUser };
